import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import "../../Styles/Firstcard.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";
import { Printer, Edit, Trash2 } from 'lucide-react';
import ViewFeeStructure from "./ViewFeeStructure"; 
import ViewFeeStructure2 from "./ViewFeeStructure2";
import { AppContext } from "../../context/AppContext";

export default function Firstcard() {
  const location = useLocation();
const item = location.state;
const {currencySymbol} = useContext(AppContext);
  const [feeCategories, setFeeCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedClass, setSelectedClass] = useState(null);
  const [viewMode, setViewMode] = useState(1); 
  const { id } = useParams();

  const viewBtnStyle = {
    fontSize: "13px",
    padding: "6px 12px",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    textDecoration: 'none' 
  };

  const iconStyle = { fontSize: "14px" };

  useEffect(() => {
    loadDataStudentFee();
  }, [id]);

  const loadDataStudentFee = async () => {
    setIsLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");


    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      academic: id, 
    };

    try {
      const response = await simplePostCall(
        ApiConfig.feeStructurecatogorylist,
        JSON.stringify(requestBody),
      );

      if (response?.result && response?.data) {
        setFeeCategories(response.data);
      } else {
        setFeeCategories([]);
      }
    } catch (error) {
      setFeeCategories([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleViewClick = (item, index) => {
    setSelectedClass(item);
    
    if (index === 0) {
      setViewMode(2);
    } else if (index === 1) {
      setViewMode(2);
    } else if (index === 2) {
      setViewMode(2);
    } else {
      setViewMode(2);
    }
  };

  if (selectedClass) {
    return (
      <>
        {(() => {
          if (viewMode === 1) {
            return (
              <ViewFeeStructure 
                data={selectedClass} 
                item={item}
                yearID={id} 
                onBack={() => setSelectedClass(null)} 
              />
            );
          } else if (viewMode === 2) {
            return (
              <ViewFeeStructure2 
                data={selectedClass} 
                yearID={id} 
                  item={item}
                onBack={() => setSelectedClass(null)} 
                 loadDataStudentFee = { loadDataStudentFee}
              />
            );
          } else if (viewMode === 3) {
            return (
              <ViewFeeStructure 
                data={selectedClass} 
                yearID={id} 
                  item={item}
                onBack={() => setSelectedClass(null)} 
              />
            );
          } else {
            return (
              <ViewFeeStructure 
                data={selectedClass} 
                yearID={id} 
                  item={item}
                onBack={() => setSelectedClass(null)} 
              />
            );
          }
        })()}
      </>
    );
  }

  return (
    <div className="firstcard-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Academic Year: {item?.academic_year_name || "2025-2026"}</h4>
        <Link to="/create-fee" state={{ item }} className="btn btn-primary">Create</Link>
      </div>

      <div className="yc-list-body">
        <div className="row fee-struc g-3">
          {isLoading ? (
            <div className="col-12 d-flex justify-content-center align-items-center" style={{ height: "20vh" }}>
              <ScaleLoader color="#F4BB44" />
            </div>
          ) : feeCategories.length > 0 ? (
            feeCategories.map((item, index) => (
              <div className="col-md-12 col-lg-4 col-sm-12" key={index}>
              <div className={`card kard${(index % 12) + 1} text-center`}>
                <div className="card-body">
                  <h5 className="card-title"><b>{item.class_name}</b></h5>
                  <p className="card-text">Total Fee: {currencySymbol} {item.amount.toLocaleString()}</p>

                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => handleViewClick(item, index)}
                  >
                    <i className="bi bi-arrow-up-right-square-fill"></i> View
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
            <div className="col-12">
              <div className="yc-empty-state">No data found for the year {item?.academic_year_name}.</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}